export interface RelatedReportElement {
    element_id: number;
    name: string;
}

/**
 * The related-report chips an answer may carry: the rows of the additional-data column that
 * name a real element, minus the report the user is already looking at (item 133: a viewer
 * never lists itself as related). The viewer's element is a front-end fact (the route), so the
 * rule lives here rather than in the context-free answer row.
 */
export function relatedReportElements(raw: unknown, currentElementId?: string | number | null): RelatedReportElement[] {
    const current =
        currentElementId === undefined || currentElementId === null || currentElementId === ''
            ? null
            : Number(currentElementId);

    return (Array.isArray(raw) ? raw : []).filter((element): element is RelatedReportElement => {
        if (!element || typeof element !== 'object') return false;
        const id = Number((element as { element_id?: unknown }).element_id);
        if (!Number.isFinite(id)) return false;
        return current === null || !Number.isFinite(current) || id !== current;
    });
}
